import styled from 'styled-components'

import { Button } from '@src/components/Button/Button'

export const SupportContainer = styled.div`
  height: 100%;
`

export const HelpQuestion = styled.p`
  font-size: 18px;
  line-height: 27px;
  font-weight: 700;
  margin: 0;
`

export const FAQsText = styled.p`
  font-size: 14px;
  line-height: 21px;
  font-weight: 400;
  margin: 4px 0 24px 0;
`

export const SubmitButton = styled(Button)`
  margin: 16px 0px;
  font-size: 18px;
`

export const InputContainer = styled.div`
  position: relative;
  margin-bottom: 16px;
`

export const Label = styled.label`
  display: block;
  margin-bottom: 4px;
  font-weight: 500;
  color: #374151;
`

export const InputWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`

export const StyledInput = styled.input`
  width: 100%;
  padding: 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 16px;
  background: transparent;
  z-index: 2;

  &:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }

  &.has-error {
    border-color: #ef4444;
  }
`

export const OutletOverlay = styled.div`
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  z-index: 1;
  display: flex;
  align-items: center;
  font-size: 16px;
`

export const OrderNumberPart = styled.span`
  color: transparent;
  white-space: pre;
`

export const OutletPart = styled.span`
  color: #9ca3af;
  font-size: 14px;
  margin-left: 8px;
  user-select: none;
`

export const ErrorText = styled.div`
  color: #ef4444;
  font-size: 14px;
  margin-top: 4px;
`
